import ajax from "./ajax";

export function requestItems(data) {
  return ajax("/items", { method: "POST", data });
}
